export enum KnownRedirects {
  VSCode = 'vscode',
  VSCodeInsiders = 'vscode-insiders',
  Windsurf = 'windsurf',
  Kiro = 'kiro',
  Cursor = 'cursor',
  Antigravity = 'antigravity',
  AuthRequest = 'auth-request',
}
